module.exports = __webpack_public_path__ + "static/media/4single.9853a274.jpg";